export const site = {
  name: 'Family Tree Maker',
  brand: 'FTM Chat Desk',
  tagline: 'Live Chat Help for Family Tree Maker',
  domain: 'familytreemakerchat.info',
  url: 'https://www.familytreemakerchat.info',
  email: 'support@familytreemakerchat.info',
  phone: '1 844 499 3050',
  phoneHref: 'tel:+18444993050',
  hours: 'Open 24 hours, 7 days a week',
  updated: 'October 10, 2026',
};

export const disclaimer =
  'familytreemakerchat.info is an independent third-party support service. We are not affiliated with, endorsed by, or sponsored by Family Tree Maker, its publisher, or any of its trademark owners. Product names and trademarks belong to their respective owners and are used here only to describe the software we help with.';

export const leadApi = {
  url: 'https://lead.dzdstech.com/api/v1/leads',
  key: 'lms_d8497da3213262fbb5611cfc4dc8ebaf187249297ff83298',
  source: 'familytreemakerchat.info',
};

export const zohoWidget =
  'https://salesiq.zohopublic.in/widget?wc=siq6819f6263d8dad7e7566213151b3ac283651dc413c53dd3e9074a8a1b079982e';
